export default "__VITE_PUBLIC_ASSET__090e504c__"